export default __webpack_public_path__ + "static/media/Group.5ada162f.svg";